const JewelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <g opacity="0.4" filter="url(#filter0_f_1064_1161)">
      <circle cx="10.4998" cy="10.7605" r="6.82105" fill="#B158E7" />
    </g>
    <g filter="url(#filter1_f_1064_1161)">
      <circle cx="10.4999" cy="8.99208" r="5.05263" fill="#B158E7" />
    </g>
    <path d="M6.13283 4.38881L2.63965 8.63269L6.13283 9.94976L8.17051 4.97417L6.13283 4.38881Z" fill="#B158E7" />
    <path d="M8.17051 4.97417L6.13283 9.94976H14.8658L12.8281 4.97417H8.17051Z" fill="#B158E7" />
    <path d="M6.13283 9.94976L10.4993 17.4131L14.8658 9.94976H6.13283Z" fill="#B158E7" />
    <path d="M2.63965 8.63269L10.4993 17.4131L6.13283 9.94976L2.63965 8.63269Z" fill="#B158E7" />
    <path d="M10.4993 17.4131L18.3589 8.63269L14.8658 9.94976L10.4993 17.4131Z" fill="#B158E7" />
    <path d="M18.3589 8.63269L14.8658 4.38881L12.8281 4.97417L14.8658 9.94976L18.3589 8.63269Z" fill="#B158E7" />
    <path
      d="M6.13283 4.38881L8.17051 4.97417H12.8281L14.8658 4.38881L10.4993 3.93945L6.13283 4.38881Z"
      fill="#B158E7"
    />

    <path
      d="M6.13283 4.38881L2.63965 8.63269L6.13283 9.94976L8.17051 4.97417L6.13283 4.38881Z"
      fill="url(#paint0_linear_1064_1161)"
      style={{ mixBlendMode: 'soft-light' }}
    />
    <path
      d="M8.17051 4.97417L6.13283 9.94976H14.8658L12.8281 4.97417H8.17051Z"
      fill="url(#paint1_linear_1064_1161)"
      style={{ mixBlendMode: 'plus-lighter' }}
    />
    <path
      d="M6.13283 9.94976L10.4993 17.4131L14.8658 9.94976H6.13283Z"
      fill="url(#paint2_linear_1064_1161)"
      style={{ mixBlendMode: 'overlay' }}
    />
    <path
      d="M2.63965 8.63269L10.4993 17.4131L6.13283 9.94976L2.63965 8.63269Z"
      fill="url(#paint3_linear_1064_1161)"
      style={{ mixBlendMode: 'soft-light' }}
    />
    <path
      d="M10.4993 17.4131L18.3589 8.63269L14.8658 9.94976L10.4993 17.4131Z"
      fill="url(#paint4_linear_1064_1161)"
      style={{ mixBlendMode: 'overlay' }}
    />
    <path
      d="M18.3589 8.63269L14.8658 4.38881L12.8281 4.97417L14.8658 9.94976L18.3589 8.63269Z"
      fill="url(#paint5_linear_1064_1161)"
      style={{ mixBlendMode: 'soft-light' }}
    />
    <path
      d="M6.13283 4.38881L8.17051 4.97417H12.8281L14.8658 4.38881L10.4993 3.93945L6.13283 4.38881Z"
      fill="url(#paint6_linear_1064_1161)"
      style={{ mixBlendMode: 'soft-light' }}
    />

    <circle cx="16.2881" cy="4.20411" r="0.350596" fill="white" />
    <circle cx="11.4494" cy="2.4504" r="0.280477" fill="white" />
    <circle opacity="0.5" cx="4.71798" cy="3.37618" r="0.280477" fill="white" />
    <circle cx="8.50254" cy="1.34922" r="0.140238" fill="white" />

    <defs>
      <filter id="filter0_f_1064_1161" x="-4.74234" y="-4.4816" width="30.4847" height="30.4847">
        <feGaussianBlur stdDeviation="4.21053" />
      </filter>
      <filter id="filter1_f_1064_1161" x="-0.447471" y="-1.95528" width="21.8949" height="21.8949">
        <feGaussianBlur stdDeviation="2.94737" />
      </filter>
      <linearGradient
        id="paint0_linear_1064_1161"
        x1="8.1414"
        y1="4.96979"
        x2="6.07573"
        y2="9.88484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#494949" />
        <stop offset="1" stopColor="#E9E9E9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1064_1161"
        x1="10.4993"
        y1="4.81817"
        x2="10.4993"
        y2="9.94403"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1064_1161"
        x1="10.4993"
        y1="9.94403"
        x2="10.4993"
        y2="17.4131"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C4C4C" />
        <stop offset="1" stopColor="#B8B8B8" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1064_1161"
        x1="6.13283"
        y1="9.94403"
        x2="10.5396"
        y2="17.3893"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#565656" />
        <stop offset="1" stopColor="#FAFAFA" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1064_1161"
        x1="15.0083"
        y1="10.0026"
        x2="10.4674"
        y2="17.3935"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#323232" />
        <stop offset="1" stopColor="#9A9A9A" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1064_1161"
        x1="12.6825"
        y1="4.67172"
        x2="14.8889"
        y2="9.93433"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#494949" />
        <stop offset="1" stopColor="#999999" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1064_1161"
        x1="10.4993"
        y1="4.09612"
        x2="10.4993"
        y2="4.96462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7C7C7C" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default JewelIcon;
